import { Message } from '@twilio/conversations';

import { getTwilioConversation } from './conversation';
import { isVisibleMessage } from './messages';
import queryClient from '../queryClient';

export const lastMessageIndexQueryKey = ['lastMessageIndex'];

export async function fetchLastMessageIndex(): Promise<number> {
  const conversation = await getTwilioConversation();

  const handleMessageAdded = (message: Message) => {
    if (!isVisibleMessage(message)) return;

    queryClient.setQueryData(lastMessageIndexQueryKey, message.index);
  };

  conversation.on('messageAdded', handleMessageAdded);

  return conversation.lastMessage?.index ?? 0;
}
